import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': localStorage.getItem('lang'),
  },
})

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    if (!error.response) {
      alert(error.message);
      return;
    }

    const {config, response: {status, data}} = error;

    switch (status) {
      case 401:
      case 403:
        try {
          await axios.get(
            `${process.env.REACT_APP_API_URL}/v1/auth/refresh`, // token refresh api
            {withCredentials: true}
          );
          const retry = await axios(config);
          return retry.data;
        } catch (error) {
          alert('로그인이 만료되었습니다. 다시 로그인해주세요.');
          window.localStorage.clear();
          const redirectUrl = encodeURI(process.env.REACT_APP_FRONT_URL)
          window.location.href = `https://auth.ziongroup.net/oauth/logout?continue=${redirectUrl}`;
        }
        break;
      case 500:
        alert(`서버에 오류가 발생했습니다. ${data?.message ?? ''}`);
        break;
      default:
        alert(data?.message ?? '알 수 없는 오류가 발생했습니다.');
        break;
    }
  }
)

export default instance;
